module.exports = __webpack_public_path__ + "static/media/智能汽车白皮书.85ce9cc5.jpg";